<template>
    <div>
      <div class="row">
        <div class="col-6">

          <dl class="row my-0 py-0">
              <dt class="col-sm-5">Provider Number:</dt>
              <dd class="col-sm-7"> {{providernumber}}</dd>
              <dt class="col-sm-5">Provider OrgID:</dt>
              <dd class="col-sm-7"> {{UserData.orgid}}</dd>
              <dt class="col-sm-5">Given Name:</dt>
              <dd class="col-sm-7">{{UserData.givenname}}</dd>              
              <dt class="col-sm-5">Surname:</dt>
              <dd class="col-sm-7">{{UserData.surname}}</dd>
              <dt class="col-sm-5">Service Type:</dt>
              <dd class="col-sm-7">{{UserData.servicetype}}</dd>
              <dt class="col-sm-5">Service Sub Type:</dt>
              <dd class="col-sm-7">{{UserData.servicesubtype}}</dd>
              <dt class="col-sm-5">Effective Date:</dt>
              <dd class="col-sm-7">{{this.effectiveDate}}</dd>
              <dt class="col-sm-5">Expiry Date:</dt>
              <dd class="col-sm-7">{{this.expiryDate}}</dd>
              <!-- <dt class="col-sm-5">Created By:</dt>
              <dd class="col-sm-7">{{UserData.createuser}}</dd>
              <dt class="col-sm-5">Last Modified By:</dt>
              <dd class="col-sm-7">{{UserData.modifyuser}}</dd> -->
              </dl>

        </div>
      <div class="col-6">
           <dl class="row my-0 py-0">
              <dt class="col-sm-5">Address:</dt>
              <dd class="col-sm-7"> {{UserData.address1}}</dd>
              <dt class="col-sm-5">Apt/Po-Box::</dt>
              <dd class="col-sm-7"> {{UserData.address2}}</dd>
              <dt class="col-sm-5">City:</dt>
              <dd class="col-sm-7"> {{UserData.address3}}</dd>
              <dt class="col-sm-5">Province:</dt>
              <dd class="col-sm-7">{{UserData.provincecode}}</dd>
              <dt class="col-sm-5">Postal Code:</dt>
              <dd class="col-sm-7">{{UserData.postalcode}}</dd>
              <dt class="col-sm-5">Phone:</dt>
              <dd class="col-sm-7">{{UserData.businessphonenumber}}</dd>
              <dt class="col-sm-5">Specialist Billing Allowed</dt>
              <dd class="col-sm-7">{{UserData.specialtyallowed}}</dd>
              <!-- <dt class="col-sm-5">Created Date:</dt>
              <dd class="col-sm-7">{{this.createDate}}</dd>
              <dt class="col-sm-5">Last Modified Date:</dt>
              <dd class="col-sm-7">{{this.modifiedDate}}</dd> -->

            </dl>
      </div>
      </div>
      
    

       <hr>
        <div class="col-sm-6">
            <button v-on:click="ClosePopup" type="button" class="btn BtnClose btn-sml float-right"><i class="fas fa-times"></i> Close Form </button>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import Vue from 'vue';
export default {
  props:{
    UserData:''
  },
data: function(){
  return{
    showMessage:false,
    payment:'',
    effectiveDate:'',
    expiryDate:'',
    createDate:'',
    modifiedDate:'',
    providernumber:''
  }

},
methods: {
  ClosePopup: function() {     
      this.$root.$emit('bv::hide::modal', 'infoModal', '#btnShow') 
    }
},
created(){
  this.effectiveDate = moment(this.UserData.effectivedate, "YYYY-MM-DD").format('YYYY/MM/DD');
  this.expiryDate = moment(this.UserData.expirydate, "YYYY-MM-DD").format('YYYY/MM/DD');
  this.createDate = moment(this.UserData.createddatetime, "YYYY-MM-DD").format('YYYY/MM/DD');
  this.modifiedDate = moment(this.UserData.lastmodifieddatetime, "YYYY-MM-DD").format('YYYY/MM/DD');

  this.providernumber = this.UserData.providernumber==undefined?'':this.UserData.providernumber
  this.providernumber = ('0000000000' + this.providernumber.toString()).substring(this.providernumber.toString().length);
  
  switch(this.UserData.codepayment){
    case 'E':
      this.payment="Electronic";
      break;
    case 'C':
      this.payment='Cheque';
      break;
    default:
      this.payment='';  
  }
  
}
}
</script>

<style>

</style>
